import { FeatureFlagTask } from "Utils/unleash/flags";
import { TextComponentNameLevel1, Variants } from "../textConstants";
import { ComponentCollection, Data, Keys, Variant } from "../textInterfaces";
import { TextManager } from "./../TextManager";

export const getCollectionOfDittoComponents = (
  componentNameLevel1: TextComponentNameLevel1,
  variant: Variant = Variants.BASE,
): ComponentCollection => {
  const allDittoComponents = TextManager.getVariant(variant);
  const unleashFeatureFlag = TextManager.isFlagEnabled(
    FeatureFlagTask.SSX_2457_ASTUDENT_NEW_TERMS_2025,
  );

  return Object.entries(allDittoComponents)
    .filter(([name]) => {
      return name.startsWith(componentNameLevel1);
    })
    .map(([name, data]) => {
      if (typeof data === "string") {
        return {
          name: name as Keys,
          text: data,
        };
      }

      if (
        "variants" in data &&
        data.variants[Variants.NEW_TERMS_2025] &&
        unleashFeatureFlag
      ) {
        data.text = data.variants["new-coverages-2025"].text;
      }

      return {
        name: name as Keys,
        text: data.text,
        status: data.status ?? undefined,
        tags: "tags" in data ? data.tags : undefined,
        variables: "variables" in data ? data.variables : undefined,
        notes: "notes" in data ? data.notes : undefined,
        plurals: "plurals" in data ? data.plurals : undefined,
      };
    })
    .reduce((acc: ComponentCollection, component: Data) => {
      const componentNameLevel2 = component.name.split(".")[1];

      if (!acc.hasOwnProperty(componentNameLevel2)) {
        acc = {
          ...acc,
          [componentNameLevel2]: [{ ...component }],
        };
      } else {
        acc[componentNameLevel2].push(component);
      }
      return acc;
    }, {});
};
